import type { NotificationRenderer } from "./types";
import { AuditStatusChangeRenderer } from "./AuditStatusChangeRenderer";
import { DocumentExpirationRenderer } from "./DocumentExpirationRenderer";
import { GenericRenderer } from "./GenericRenderer";

export type { NotificationRenderer } from "./types";
export { BodyCard } from "./BodyCard";
export { AuditStatusChangeRenderer } from "./AuditStatusChangeRenderer";
export { DocumentExpirationRenderer } from "./DocumentExpirationRenderer";
export { GenericRenderer } from "./GenericRenderer";

// ---------------------------------------------------------------------------
// Renderer Registry
// ---------------------------------------------------------------------------

const RENDERER_REGISTRY: Record<string, NotificationRenderer> = {
  audit_status_change: AuditStatusChangeRenderer,
  document_expiration: DocumentExpirationRenderer,
};

export function getRenderer(category: string): NotificationRenderer {
  return RENDERER_REGISTRY[category] ?? GenericRenderer;
}

// --- Future Notification Type Renderers ------------------------------------
//
// To add a new notification type:
// 1. Create a new renderer file: `renderers/FindingRenderer.tsx`
// 2. Implement the `NotificationRenderer` interface
// 3. Add to RENDERER_REGISTRY below with the backend category string as key
// 4. Add the category + config to `notificationConfig.ts`
//
// Planned future types (from src/packages/types/src/events.ts):
//   finding_created        -> FindingRenderer (severity badge, finding title, audit link)
//   finding_resolved       -> FindingRenderer (resolved status, resolver name)
//   checklist_item_completed -> ChecklistRenderer (item title, progress %)
//   ai_processing_complete -> AIProcessingRenderer (task type, duration)
//   ai_processing_failed   -> AIProcessingRenderer (error message, retry action)
//   team_assignment        -> TeamAssignmentRenderer (role, assigning user, audit)
//   audit_deadline         -> AuditDeadlineRenderer (deadline date, urgency)
// ---------------------------------------------------------------------------
